export default __webpack_public_path__ + "static/media/video-placeholder-2.987575ec.png";